import styled from 'styled-components';

export const MobilePortfolioRespawnStyled = styled.div`
    display: flex;
    padding: 0 16px;
    height: 100%;
    align-items: center;
    justify-content: center;
    background: rgba(15, 18, 20, 0.3);
    backdrop-filter: blur(3px);
    position: relative;
`;

export const MobilePortfolioRespawnContentStyled = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    width: 100%;
    position: relative;
    max-width: 350px;
    
    h2 {
        font-weight: 400;
        margin-top: 16px;
    }
    
    p {
        margin-top: 16px;
        margin-bottom: 0;
    }
    
    button {
        margin-top: 20px;
    }
`;

export const MobilePortfolioRespawnBackgroundStyled = styled.div`
    position: absolute;
    width: 282px;
    height: 260px;
    left: 12%;
    top: -10px;
    background: #2744AA;
    opacity: 0.8;
    filter: blur(83.5px);
    z-index: -1;
    
    &:before {
        content: '';
        position: absolute;
        width: 193.14px;
        height: 183.83px;
        left: 0;
        top: 120px;
        background: #287B00;
        opacity: 0.3;
        filter: blur(62px);
        transform: rotate(12.01deg);
    }
    
    &:after {
        content: '';
        position: absolute;
        width: 193.14px;
        height: 183.83px;
        left: 0;
        top: 0;
        background: #FFFA00;
        opacity: 0.3;
        filter: blur(62px);
        transform: rotate(12.01deg);
    }
`;

export const MobilePortfolioRespawnCloseButtonStyled = styled.div`
    display: flex;
    background: var(--color-neutral-20);
    border-radius: 16px;
    padding: 8px;
    position: absolute;
    top: 24px;
    right: 16px;
    
    svg {
        fill: var(--color-white-60);
    }
`;

export const MobilePortfolioRespawnImageWrapperStyled = styled.div`
    img {
        height: 120px;
        width: 120px;
    }
`;
